import { render, staticRenderFns } from "./drawerBottom.component.vue?vue&type=template&id=47e32e5f&scoped=true"
import script from "./drawerBottom.component.vue?vue&type=script&lang=js"
export * from "./drawerBottom.component.vue?vue&type=script&lang=js"
import style0 from "./drawerBottom.component.vue?vue&type=style&index=0&id=47e32e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e32e5f",
  null
  
)

export default component.exports